import type { CustomFieldEntity, CustomFieldScope, CustomFieldType } from './entity_types/CustomField';
import { hFetch } from './hFetch';

const basePath = '/api/custom_fields';

export type CustomFieldPayload = {
  name: string;
  key: string;
  field_type: CustomFieldType;
  scopes: CustomFieldScope[];
  options: string[];
  sensitive: boolean;
  auto_collect_during_onboarding: boolean;
};

export type CustomFieldMutationResponse = {
  status?: 'success' | 'error';
  message?: string;
  record?: CustomFieldEntity;
};

export const listCustomFields = async () => {
  return await hFetch<{ records: CustomFieldEntity[] }>({ url: basePath });
};

export const listCustomFieldsForEntity = async ({ entity }: { entity: CustomFieldScope }) => {
  return await hFetch<{ records: CustomFieldEntity[] }>({ url: `${basePath}?entity=${entity}` });
};

export const getCustomField = async ({ id }: { id: number }) => {
  return await hFetch<{ record: CustomFieldEntity }>({ url: `${basePath}/${id}` });
};

export const createCustomField = async ({ body }: { body: CustomFieldPayload }) => {
  return await hFetch<CustomFieldMutationResponse, { custom_field: CustomFieldPayload }>({
    url: basePath,
    method: 'POST',
    payload: {
      custom_field: body,
    },
  });
};

export const updateCustomField = async ({ id, body }: { id: number; body: CustomFieldPayload }) => {
  return await hFetch<CustomFieldMutationResponse, { custom_field: CustomFieldPayload }>({
    url: `${basePath}/${id}`,
    method: 'PATCH',
    payload: {
      custom_field: body,
    },
  });
};

export const deleteCustomField = async ({ id }: { id: number }) => {
  return await hFetch({ url: `${basePath}/${id}`, method: 'DELETE' });
};
